import { useMemo } from "react";
import each from "lodash/each";
import get from "lodash/get";
import getFieldDefaultValue from "./getFieldDefaultValue";

/**
 * Automatically generates the form's `initialValues` based on the fields configuration.
 *
 * Note: if a valid value for `initialValues` is passed in, this is returned instead. This allows a custom
 * `initialValues` to be used when needed (instead of the auto-generated one).
 *
 * Note that logic needs to be kept in sync with rules enforced in `useSchemaFromFields` and
 * `mapFormFieldsToActionFormData`.
 */
function useInitialValuesFromFields(initialValues, fields) {
  return useMemo(() => {
    if (initialValues) {
      return initialValues;
    }

    const fieldsInitialValues = {};

    each(Object.keys(fields), key => {
      const field = get(fields, key, null);
      const type = get(field, "type", null);
      const mode = get(field, "mode", null);

      fieldsInitialValues[key] = getFieldDefaultValue(type, { mode });
    });

    return fieldsInitialValues;
  }, [initialValues, fields]);
}

export default useInitialValuesFromFields;
